import {updatePuck} from '../components/puckSizer';

export function setupProductDescription() {
    let triggerEl = document.querySelector('[data-puck-component="puck-default"]'),
        puckTriggers = document.querySelectorAll('[data-product-component="puck-trigger"]');

    updatePuck(triggerEl);

    [].forEach.call(puckTriggers, currentTrigger => currentTrigger.addEventListener('click', handlePuckTrigger));
}

function handlePuckTrigger() {
    updatePuck(this);
}
